import { IsColumnMasked } from '../constants/columns';
import { GetCellValue } from './derive/CellValue';

const COLLATOR_PT_BR = new Intl.Collator('pt-BR', { numeric: true, sensitivity: 'base' });

/**
 * Sort puro: aplica sortCol/sortDir em rows e devolve nova lista. Estável.
 *
 * Comparador:
 *   - null/undefined/'' sempre vão pro FIM.
 *   - Strings usam localeCompare pt-BR (numeric:true).
 *   - Números cai em compare numérico normal.
 *
 * @param {import('./contract').Row[]} rows
 * @param {string|null} sortCol
 * @param {'asc'|'desc'} sortDir
 * @param {number|null} periodDays
 * @param {Object|null} ctx                 customColumnsById + periodDays
 * @returns {import('./contract').Row[]}
 */
export function SortRows(rows, sortCol, sortDir, periodDays = null, ctx = null) {
    if (!sortCol) return rows;
    if (IsColumnMasked(sortCol, periodDays)) return rows;
    const sign = sortDir === 'asc' ? 1 : -1;
    return [...rows].sort((a, b) => {
        const av = GetCellValue(a, sortCol, ctx);
        const bv = GetCellValue(b, sortCol, ctx);
        const aMissing = av === null || av === undefined || av === '';
        const bMissing = bv === null || bv === undefined || bv === '';
        if (aMissing && bMissing) return 0;
        if (aMissing) return 1;
        if (bMissing) return -1;
        if (typeof av === 'string' || typeof bv === 'string') {
            return COLLATOR_PT_BR.compare(String(av), String(bv)) * sign;
        }
        const na = Number(av);
        const nb = Number(bv);
        if (na === nb) return 0;
        return (na < nb ? -1 : 1) * sign;
    });
}
